import { Select } from "antd";
import { useEffect } from "react";
/**In progress */
export default function CrrGroupedMultiselect(props) {
  const {
    qnId = "", // to check if the page using the component is pre-assessment
    selectField,
    placeholderText,
    onChange,
    options,
    disabled,
    setValue,
    answer,
    value,
    form,
  } = props;

  useEffect(() => {
    setValue(answer ? answer.map((answer) => answer.id) : []);
  }, [answer]);

  const handleOnChange = (value) => {
    form.setFieldsValue({
      [qnId]: value,
    });
    setValue(value);
  };

  const handleOnBlur = (value) => {
    if (onChange) {
      if (qnId) {
        onChange({ question_id: qnId, text_answer: value });
      } else {
        onChange(value);
      }
    }
  };
  return (
    <Select
      className="login-input"
      mode="multiple"
      showSearch
      onSearch={() => {}}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      dropdownClassName="form-dropdown"
      placeholder={!selectField && placeholderText}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      // defaultValue={defaultValue}
      value={value}
      bordered={false}
      disabled={disabled}
    >
      {options &&
        options.map((group, groupIndex) => (
          <Select.OptGroup label={group.group} key={groupIndex}>
            {group.group}
            {group?.options &&
              group?.options.map((option, optionIndex) => (
                <Select.Option key={option.id} value={option.id || option.name}>
                  {option.option}
                </Select.Option>
              ))}
          </Select.OptGroup>
        ))}
    </Select>
  );
}
